import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/swishr-pulse-v-119f21a/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/swishr-pulse-v-119f21a/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/workspace/swishr-pulse-v-119f21a/src/components/layout/language-switcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/swishr-pulse-v-119f21a/src/providers/index.tsx");
